module.exports = __webpack_public_path__ + "media/wyposazenie/opis-2f6caf9e.png";